import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import moment from "moment";
import getactions from "../../common/getactions";
import { useSelector } from "react-redux";

const Servicetimeline = ({
  getWorkOrderDetails,
  selectedRow,
  workOrderDetail,
  vehicleTaskDetails,
  vehicleServicePartDetails,
  serviceLabourCost,
  insurancePostReponse,
  handleImageOpen,
  timeLineData,
  setTimeLineData,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const isSystemUserList = useSelector(
    (state) => state?.isSystemUser?.isSysTemUserData?.entities?.rows,
  );

  const [timeLine, setTimeLine] = useState([]);
  const [formData, setFormData] = useState({});
  const [openIndex, setOpenIndex] = useState(null);
  const [estimationHistory, setEstimationHistory] = useState([]);
  const [paymentRejectHistory, setPaymentRejectHistory] = useState([]);
  const [rejectMode, setRejectMode] = useState({});
  const [loading, setLoading] = useState(false);

  const disabledSaveTimelineTitles = [
    "Vehicle pick up from Hub",
    "Vehicle drop to Service station",
    "Vehicle Pick From Service Station",
    "Vehicle Drop To Hub",
    "Service Complete",
  ];

  const isSaveDisabledForStep = (step) => {
    return disabledSaveTimelineTitles.includes(step?.title);
  };

  const toggleAccordion = (index) => {
    // const firstIncompleteIndex = timeLine.findIndex((step) => {
    //   const data = timeLineData.find((item) => item.timelineId === step.id);
    //   return data?.status !== true;
    // });

    // const isPaymentApproval =
    //   workorderStatus[workOrderDetail?.serviceStatus] ===
    //   "Billing Approval Request";

    // if (firstIncompleteIndex === -1) {
    //   setFormData({});
    //   setRejectMode({});
    //   setOpenIndex(openIndex === index ? null : index);
    //   return;
    // }

    // if (isPaymentApproval) {
    //   if (index >= firstIncompleteIndex) {
    //     return;
    //   }
    // } else {
    //   if (index > firstIncompleteIndex) {
    //     return;
    //   }
    // }

    setFormData({});
    setRejectMode({});
    setOpenIndex(openIndex === index ? null : index);
  };

  // const toggleAccordion = (index) => {
  //   // find first incomplete step
  //   const firstIncompleteIndex = timeLine.findIndex((step) => {
  //     const data = timeLineData.find((item) => item.timelineId === step.id);
  //     return data?.status !== true;
  //   });

  //   // ✅ if ALL steps completed → allow all
  //   if (firstIncompleteIndex === -1) {
  //     setFormData({});
  //     setRejectMode({});
  //     setOpenIndex(openIndex === index ? null : index);
  //     return;
  //   }

  //   // ✅ allow:
  //   // 1. completed steps (index < firstIncompleteIndex)
  //   // 2. next step (index === firstIncompleteIndex)
  //   if (index > firstIncompleteIndex) {
  //     return; // ❌ block future steps
  //   }

  //   setFormData({});
  //   setRejectMode({});
  //   setOpenIndex(openIndex === index ? null : index);
  // };

  useEffect(() => {
    getTimeLIneDetails();
  }, []);

  useEffect(() => {
    if (timeLineData.length > 0) {
      const estimationData = timeLineData.find(
        (item) =>
          item.title === "Estimation Approval" && item?.status === false,
      );

      if (estimationData) {
        try {
          const values = JSON.parse(estimationData.timelineValues);
          setEstimationHistory(values.serviceEstimationHistories || []);
        } catch (err) {
          console.error("Error parsing estimation history:", err);
        }
      }
    }

    if (timeLineData.length > 0) {
      const rejectionData = timeLineData.find(
        (item) => item.title === "Final Billing Approval",
      );

      if (rejectionData) {
        try {
          const values = JSON.parse(rejectionData.timelineValues);
          setPaymentRejectHistory(values.paymentRequestRequestHistories || []);
        } catch (err) {
          console.error("Error parsing payment request history:", err);
        }
      }
    }

    // if (timeLineData.length > 0) {
    //   const rejectioData = timeLineData.find(
    //     (item) => item.title === "Final Billing Approval",
    //   );

    //   if (rejectioData) {
    //     try {
    //       const values = JSON.parse(rejectioData.timelineValues);

    //       const history = values.paymentRequestRequestHistories || [];
    //       setPaymentRejectHistory(history);

    //       const lastAction = history[history.length - 1];

    //       if (lastAction?.status === "REJECTED") {
    //         const index = timeLine.findIndex(
    //           (step) => step.id === rejectioData.timelineId,
    //         );
    //         setOpenIndex(index);

    //         setRejectMode({
    //           rejectComment: lastAction?.comment || "",
    //           rejectAttachment: lastAction?.attachments || [],
    //         });
    //       }
    //     } catch (err) {
    //       console.error("Error parsing payment reject history:", err);
    //     }
    //   }
    // }
  }, [timeLineData]);

  useEffect(() => {
    if (workOrderDetail?.id) {
      getTimeLIneDataDetails(workOrderDetail?.id);
    }
  }, [workOrderDetail]);

  const getTimeLIneDetails = async () => {
    if (!token) return toast.error("Session expired");
    setLoading(true);

    try {
      const res = await fetch(`${apiUrl}/api/predefineservicechecklistitems`, {
        headers: { Authorization: token },
      });
      const data = await res.json();

      if (data?.statusCode === "0100") {
        const sorted = data.entities.rows.sort((a, b) => a.seqId - b.seqId);
        setTimeLine(sorted);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getTimeLIneDataDetails = async (id) => {
    try {
      const res = await fetch(
        `${apiUrl}/api/servicetimelines?serviceLogId=${id}`,
        {
          headers: { Authorization: token },
        },
      );
      const data = await res.json();

      if (data?.statusCode === "0100") {
        setLoading(false);
        setTimeLineData(data.entities.rows || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };
  

  const handleFileChange = async (key, files) => {
    toast.loading("Image Upload Processing... Please wait", {
      id: "upload", // same ID to update later
      position: "bottom-center",
    });
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");
    toast.dismiss("upload");
    if (key === "rejectAttachment") {
      setRejectMode((prev) => ({
        ...prev,
        [key]: res?.uploaded || [],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [key]: res?.uploaded || [],
      }));
    }
  };

  const fuelMeterReading = [
    { label: "5%", value: 5 },
    { label: "10%", value: 10 },
    { label: "15%", value: 15 },
    { label: "20%", value: 20 },
    { label: "25%", value: 25 },
    { label: "30%", value: 30 },
    { label: "35%", value: 35 },
    { label: "40%", value: 40 },
    { label: "45%", value: 45 },
    { label: "50%", value: 50 },
    { label: "55%", value: 55 },
    { label: "60%", value: 60 },
    { label: "65%", value: 65 },
    { label: "70%", value: 70 },
    { label: "75%", value: 75 },
    { label: "80%", value: 80 },
    { label: "85%", value: 85 },
    { label: "90%", value: 90 },
    { label: "95%", value: 95 },
    { label: "100%", value: 100 },
  ];

  const inputFieldsValues = {
    hubPickUpForm: [
      {
        type: "number",
        label: "Starting Odometer Reading *",
        value: null,
        subCategory: null,
        apiKey: "startingOdometerReading",
        defaultValue: workOrderDetail?.odometerReading || 0,
        readOnly: true,
        disabled: true,
      },
      {
        type: "select",
        label: "Starting Fuel Reading *",
        value: null,
        subCategory: fuelMeterReading,
        apiKey: "startingFuelReading",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
      {
        type: "file",
        label: "Starting Odometer Image *",
        value: null,
        subCategory: null,
        apiKey: "startingOdometerImage",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
    ],
    dropServiceStation: [
      {
        type: "number",
        label: "End Odometer Reading *",
        value: null,
        subCategory: null,
        apiKey: "endOdometerReading",
        defaultValue:
          timeLineData &&
          JSON.parse(
            timeLineData.find(
              (item) =>
                item.title === "Vehicle pick up from Hub" &&
                item?.status === true,
            )?.timelineValues || "{}",
          )?.startingOdometerReading,
        readOnly: true,
        disabled: true,
      },
      {
        type: "select",
        label: "End Fuel Reading *",
        value: null,
        subCategory: fuelMeterReading,
        apiKey: "endFuelReading",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
      {
        type: "file",
        label: "End Odometer Image *",
        value: null,
        subCategory: null,
        apiKey: "endOdometerImage",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
    ],
    estimation: [
      {
        type: "number",
        label: "Estimation Amount",
        value: null,
        subCategory: null,
        apiKey: "estimationAmount",
        defaultValue: null,
      },
      {
        type: "textarea",
        label: "Description",
        value: null,
        subCategory: null,
        apiKey: "description",
        defaultValue: null,
      },
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
      },
      {
        type: "content",
        label: "Estimation History",
        value: null,
        subCategory: estimationHistory,
        apiKey: "estimationHistory",
        defaultValue: null,
      },
    ],
    estimationApprovalFlow: [
      {
        type: "number",
        label: "Insurance Amount",
        value: insurancePostReponse?.approvedAmount,
        subCategory: null,
        apiKey: "insuranceAmount",
        disabled: true,
        defaultValue: null,
      },
      {
        type: "number",
        label: "Total Task amount",
        value: vehicleTaskDetails?.reduce(
          (sum, item) => sum + Number(Number(item.totalCost) || 0),
          0,
        ),
        subCategory: null,
        apiKey: "totalTaskAmount",
        disabled: true,
        defaultValue: null,
      },
      {
        type: "number",
        label: "Total Parts amount",
        value: vehicleServicePartDetails?.reduce(
          (sum, item) => sum + Number(Number(item.totalCost).toFixed(2) || 0),
          0,
        ),
        subCategory: null,
        apiKey: "totalPartsAmount",
        disabled: true,
        defaultValue: null,
      },
      {
        type: "number",
        label: "Total Labours amount",
        value: serviceLabourCost?.reduce(
          (sum, item) => sum + Number(Number(item.totalAmount) || 0),
          0,
        ),
        subCategory: null,
        apiKey: "totalPartsAmount",
        disabled: true,
        defaultValue: null,
      },
      {
        type: "number",
        label: "Estimated Amount",
        value:
          timeLineData &&
          JSON.parse(
            timeLineData.find((item) => item.title === "Service Estimation")
              ?.timelineValues || "{}",
          )?.estimationAmount,
        subCategory: null,
        apiKey: "estimatedAmount",
        disabled: true,
        defaultValue: null,
      },
      // {
      //   type: "number",
      //   label: "Discounted Amount",
      //   value: null,
      //   subCategory: null,
      //   apiKey: "discountedAmount",
      // },
      // {
      //   type: "text",
      //   label: "Approved By",
      //   value: null,
      //   subCategory: null,
      //   apiKey: "approvedBy",
      // },
      // {
      //   type: "date",
      //   label: "Approved On",
      //   value: null,
      //   subCategory: null,
      //   apiKey: "approvedOn",
      // },
      // {
      //   type: "select",
      //   label: "Approved Status",
      //   value: null,
      //   subCategory: [
      //     { label: "Approved", value: "approved" },
      //     { label: "Rejected", value: "rejected" },
      //     { label: "Pending", value: "pending" },
      //   ],
      //   apiKey: "approvedStatus",
      // },
      {
        type: "textarea",
        label: "Description",
        value: null,
        subCategory: null,
        apiKey: "description",
        defaultValue: null,
      },
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
      },
      {
        type: "content",
        label: "Estimation History",
        value: null,
        subCategory: estimationHistory,
        apiKey: "estimationHistory",
        defaultValue: null,
      },
    ],
    jobProgress: [
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
      },
    ],
    finalBillingRequest: [
      {
        type: "number",
        label: "Payment Amount",
        value: null,
        subCategory: null,
        apiKey: "paymentAmount",
        defaultValue: null,
      },
      {
        type: "number",
        label: "Insurance Amount Claimed",
        value: null,
        subCategory: null,
        apiKey: "insuranceAmountClaimed",
        defaultValue: null,
      },
      {
        type: "number",
        label: "Cost To The Company",
        value: null,
        subCategory: null,
        apiKey: "costToTheCompany",
        defaultValue: null,
      },
      // {
      //   type: "select",
      //   label: "Payment Mode",
      //   value: null,
      //   subCategory: [
      //     { label: "Cash", value: "cash" },
      //     { label: "Card", value: "card" },
      //     { label: "UPI", value: "upi" },
      //   ],
      //   apiKey: "paymentMode",
      // },
      // {
      //   type: "text",
      //   label: "Transaction Id",
      //   value: null,
      //   subCategory: null,
      //   apiKey: "transactionId",
      // },
      // {
      //   type: "date",
      //   label: "Payment Date",
      //   value: null,
      //   subCategory: null,
      //   apiKey: "paymentDate",
      // },
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
      },
      {
        type: "content",
        label: "Final Billing Approval Rejection History",
        value: null,
        subCategory: paymentRejectHistory,
        apiKey: "paymentRejectHistory",
        defaultValue: null,
      },
    ],
    jobCompletion: [
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
      },
    ],
    "Payment Confirmation": [
      {
        type: "number",
        label: "Payment Amount",
        value: null,
        subCategory: null,
        apiKey: "paymentAmount",
        defaultValue: null,
      },
      {
        type: "select",
        label: "Payment Mode",
        value: null,
        subCategory: [
          { label: "Cash", value: "cash" },
          { label: "Card", value: "card" },
          { label: "UPI", value: "upi" },
        ],
        apiKey: "paymentMode",
        defaultValue: null,
      },
      {
        type: "text",
        label: "Transaction Id",
        value: null,
        subCategory: null,
        apiKey: "transactionId",
        defaultValue: null,
      },
      {
        type: "date",
        label: "Payment Date",
        value: null,
        subCategory: null,
        apiKey: "paymentDate",
        defaultValue: null,
      },
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
      },
    ],
    pickupFromServiceStation: [
      {
        type: "number",
        label: "Starting Odometer Reading *",
        value: null,
        subCategory: null,
        apiKey: "startingOdometerReading",
        defaultValue:
          timeLineData &&
          JSON.parse(
            timeLineData.find(
              (item) =>
                item.title === "Vehicle drop to Service station" &&
                item?.status === true,
            )?.timelineValues || "{}",
          )?.endOdometerReading,
        readOnly: true,
        disabled: true,
      },
      {
        type: "select",
        label: "Starting Fuel Reading *",
        value: null,
        subCategory: fuelMeterReading,
        apiKey: "startingFuelReading",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
      {
        type: "file",
        label: "Starting Odometer Image *",
        value: null,
        subCategory: null,
        apiKey: "startingOdometerImage",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
    ],
    vehicleDropToHub: [
      {
        type: "number",
        label: "End Odometer Reading *",
        value: null,
        subCategory: null,
        apiKey: "endOdometerReading",
        defaultValue:
          timeLineData &&
          JSON.parse(
            timeLineData.find(
              (item) =>
                item.title === "Vehicle Pick From Service Station" &&
                item?.status === true,
            )?.timelineValues || "{}",
          )?.startingOdometerReading,
        readOnly: true,
        disabled: true,
      },
      {
        type: "select",
        label: "End Fuel Reading *",
        value: null,
        subCategory: fuelMeterReading,
        apiKey: "endFuelReading",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
      {
        type: "file",
        label: "End Odometer Image *",
        value: null,
        subCategory: null,
        apiKey: "endOdometerImage",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
        readOnly: true,
        disabled: true,
      },
    ],
    serviceCompletion: [
      {
        type: "file",
        label: "Attachments",
        value: null,
        subCategory: null,
        apiKey: "attachment",
        defaultValue: null,
      },
      {
        type: "textarea",
        label: "Description",
        value: null,
        subCategory: null,
        apiKey: "description",
        defaultValue: null,
      },
    ],
  };

  const renderInputs = (step) => {
    const fields = inputFieldsValues[step.timelineId];
    if (!fields) return <p>No inputs</p>;

    return fields.map((field) => {
      const key = field.apiKey;

      return (
        <div key={key} className="grid grid-cols-4 gap-2 mt-4 p-4">
          <label>{field.label}</label>

          {field.type === "text" && (
            <input
              onChange={(e) => handleChange(key, e.target.value)}
              className="input border border-gray-400"
              disabled={field?.readOnly}
            />
          )}

          {field.type === "date" && (
            <input
              type="date"
              onChange={(e) => handleChange(key, e.target.value)}
              className="input border border-gray-400"
              disabled={field?.readOnly}
            />
          )}

          {field.type === "content" &&
            estimationHistory.length > 0 &&
            step?.title !== "Final Billing Approval" && (
              // (field?.subCategory.length > 0 ? (
              <div className="border p-2 max-h-48 overflow-y-auto w-full col-span-3">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-3 py-2 text-left">Amount</th>
                      <th className="border px-3 py-2 text-left">
                        Reject Comment
                      </th>
                      <th className="border px-3 py-2 text-left">
                        Reject Attachments
                      </th>
                      <th className="border px-3 py-2 text-left">
                        Rejected By
                      </th>
                    </tr>
                  </thead>

                  {estimationHistory.length > 0 && (
                    <tbody>
                      {estimationHistory.length > 0 ? (
                        estimationHistory.map((item, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="border px-3 py-2">
                              {item.estimationAmount}
                            </td>
                            <td className="border px-3 py-2">{item.comment}</td>
                            <td className="border px-3 py-2">
                              <div className="flex space-x-2">
                                {item.rejectAttachment?.length > 0 ? (
                                  item.rejectAttachment.map((file, i) => (
                                    <img
                                      key={i}
                                      src={file.url}
                                      alt={`Attachment ${i + 1}`}
                                      onClick={() => {
                                        handleImageOpen(
                                          file?.url ||
                                            file?.Location ||
                                            file?.image ||
                                            file?.path,
                                        );
                                      }}
                                      className="w-10 h-10 object-cover rounded"
                                    />
                                  ))
                                ) : (
                                  <span className="text-gray-400">
                                    No attachments
                                  </span>
                                )}
                              </div>
                            </td>
                            <td className="border px-3 py-2">
                              {item.rejectedBy}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-3">
                            No Estimation history available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
            )}

          {field.type === "content" &&
            paymentRejectHistory?.length > 0 &&
            step?.title === "Final Billing Approval" && (
              // (field?.subCategory.length > 0 ? (
              <div className="border p-2 max-h-48 overflow-y-auto w-full col-span-3">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-3 py-2 text-left">Amount</th>
                      <th className="border px-3 py-2 text-left">
                        Reject Comment
                      </th>
                      <th className="border px-3 py-2 text-left">
                        Reject Attachments
                      </th>
                      <th className="border px-3 py-2 text-left">
                        Rejected By
                      </th>
                    </tr>
                  </thead>

                  {paymentRejectHistory.length > 0 && (
                    <tbody>
                      {paymentRejectHistory.length > 0 ? (
                        paymentRejectHistory.map((item, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="border px-3 py-2">
                              {item.paymentAmount}
                            </td>
                            <td className="border px-3 py-2">{item.comment}</td>
                            <td className="border px-3 py-2">
                              <div className="flex space-x-2">
                                {item.rejectAttachment?.length > 0 ? (
                                  item.rejectAttachment.map((file, i) => (
                                    <img
                                      key={i}
                                      src={file.url}
                                      alt={`Attachment ${i + 1}`}
                                      onClick={() => {
                                        handleImageOpen(
                                          file?.url ||
                                            file?.Location ||
                                            file?.image ||
                                            file?.path,
                                        );
                                      }}
                                      className="w-10 h-10 object-cover rounded"
                                    />
                                  ))
                                ) : (
                                  <span className="text-gray-400">
                                    No attachments
                                  </span>
                                )}
                              </div>
                            </td>
                            <td className="border px-3 py-2">
                              {item.rejectedBy}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-3">
                            No Payment Reject history available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
            )}

          {field.type === "select" && (
            <select
              disabled={field?.readOnly}
              className="input border border-gray-400"
              onChange={(e) => handleChange(key, e.target.value)}
            >
              <option>Select</option>
              {field.subCategory?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}

          {field.type === "number" && (
            <>
              <input
                type="number"
                onChange={(e) => handleChange(key, e.target.value)}
                className="input border border-gray-400"
                value={formData[key] ?? field?.value ?? ""}
                disabled={field?.disabled}
                readOnly={field?.readOnly}
              />
              {field.type === "number" && field?.defaultValue !== null && (
                <p className="text-blue-800 text-sm font-bold">
                  Current Odometer - {field?.defaultValue + " / Km"}
                </p>
              )}
            </>
          )}

          {field.type === "textarea" && (
            <textarea
              onChange={(e) => handleChange(key, e.target.value)}
              className="input border border-gray-400"
              value={field?.value}
              disabled={field?.readOnly}
            ></textarea>
          )}

          {field.type === "file" && (
            <>
              <input
                type="file"
                multiple
                onChange={(e) => handleFileChange(key, e.target.files)}
                disabled={field?.readOnly}
              />
              {formData[key]?.length > 0 && (
                <div className="mt-2 grid grid-cols-4 gap-2">
                  {formData[key]?.map((file, index) => {
                    const fileUrl =
                      file?.url ||
                      file?.Location ||
                      file?.image ||
                      file?.path ||
                      "";

                    const fileName = fileUrl.split("/").pop();
                    const extension = fileName?.split(".").pop()?.toLowerCase();

                    const isImage = [
                      "jpg",
                      "jpeg",
                      "png",
                      "gif",
                      "webp",
                    ].includes(extension);
                    const isVideo = ["mp4", "webm", "ogg"].includes(extension);
                    const isPDF = extension === "pdf";

                    return (
                      <div
                        key={index}
                        className="w-16 h-16 border rounded overflow-hidden flex items-center justify-center cursor-pointer"
                        onClick={() => handleImageOpen(fileUrl)}
                      >
                        {/* IMAGE */}
                        {isImage && (
                          <img
                            src={fileUrl}
                            alt={`Attachment ${index + 1}`}
                            className="w-full h-full object-cover"
                          />
                        )}

                        {/* VIDEO */}
                        {isVideo && (
                          <video className="w-full h-full object-cover">
                            <source src={fileUrl} type={`video/${extension}`} />
                          </video>
                        )}

                        {/* PDF */}
                        {isPDF && (
                          <div className="text-xs text-red-500 text-center">
                            📄 PDF
                          </div>
                        )}

                        {/* OTHER FILES */}
                        {!isImage && !isVideo && !isPDF && (
                          <div className="text-xs text-gray-500 text-center">
                            📁 File
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}
        </div>
      );
    });
  };

  const parseTimelineValues = (savedData) => {
    if (!savedData) return {};
    try {
      return JSON.parse(savedData.timelineValues || "{}");
    } catch {
      return {};
    }
  };

  const getFileType = (url) => {
    if (!url) return "unknown";

    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt"].includes(ext))
      return "document";

    return "unknown";
  };

  const renderSavedData = (step, savedData) => {
    const fields = inputFieldsValues[step.timelineId];
    if (!fields) return null;

    let values = {};
    try {
      values = JSON.parse(savedData.timelineValues || "{}");
    } catch {}

    return fields.map((field) => {
      const value = values[field.apiKey];

      return (
        <>
          <div key={field.apiKey} className="grid grid-cols-4 gap-2 p-4">
            <label>{field.label} : </label>

            {field.type === "content" && (
              <div className="w-full col-span-3">
                {estimationHistory.length > 0 &&
                  step?.title !== "Final Billing Approval" && (
                    <table className="min-w-full border border-gray-300 text-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border px-3 py-2 text-left">Amount</th>
                          <th className="border px-3 py-2 text-left">
                            Description
                          </th>
                          <th className="border px-3 py-2 text-left">
                            Attachments
                          </th>
                          <th className="border px-3 py-2 text-left">
                            Rejected By
                          </th>
                        </tr>
                      </thead>

                      {estimationHistory.length > 0 && (
                        <tbody>
                          {estimationHistory.length > 0 ? (
                            estimationHistory.map((item, index) => (
                              <tr key={index} className="hover:bg-gray-50">
                                <td className="border px-3 py-2">
                                  {item.estimationAmount}
                                </td>
                                <td className="border px-3 py-2">
                                  {item.comment}
                                </td>

                                <td className="border px-3 py-2">
                                  <div className="flex space-x-2">
                                    {item.rejectAttachment?.length > 0 ? (
                                      item.rejectAttachment.map((file, i) => (
                                        <img
                                          key={i}
                                          src={file.url}
                                          onClick={() => {
                                            handleImageOpen(
                                              file?.url ||
                                                file?.Location ||
                                                file?.image ||
                                                file?.path,
                                            );
                                          }}
                                          alt={`Attachment ${i + 1}`}
                                          className="w-10 h-10 object-cover rounded"
                                        />
                                      ))
                                    ) : (
                                      <span className="text-gray-400">
                                        No attachments
                                      </span>
                                    )}
                                  </div>
                                </td>
                                <td className="border px-3 py-2">
                                  {item.rejectedBy}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center py-3">
                                No history available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  )}

                {paymentRejectHistory.length > 0 &&
                  step?.title === "Final Billing Approval" && (
                    <table className="min-w-full border border-gray-300 text-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border px-3 py-2 text-left">Amount</th>
                          <th className="border px-3 py-2 text-left">
                            Description
                          </th>
                          <th className="border px-3 py-2 text-left">
                            Attachments
                          </th>
                          <th className="border px-3 py-2 text-left">
                            Rejected By
                          </th>
                        </tr>
                      </thead>

                      {paymentRejectHistory.length > 0 && (
                        <tbody>
                          {paymentRejectHistory.length > 0 ? (
                            paymentRejectHistory.map((item, index) => (
                              <tr key={index} className="hover:bg-gray-50">
                                <td className="border px-3 py-2">
                                  {item.paymentAmount}
                                </td>
                                <td className="border px-3 py-2">
                                  {item.comment}
                                </td>

                                <td className="border px-3 py-2">
                                  <div className="flex space-x-2">
                                    {item.rejectAttachment?.length > 0 ? (
                                      item.rejectAttachment.map((file, i) => (
                                        <img
                                          key={i}
                                          src={file.url}
                                          onClick={() => {
                                            handleImageOpen(
                                              file?.url ||
                                                file?.Location ||
                                                file?.image ||
                                                file?.path,
                                            );
                                          }}
                                          alt={`Attachment ${i + 1}`}
                                          className="w-10 h-10 object-cover rounded"
                                        />
                                      ))
                                    ) : (
                                      <span className="text-gray-400">
                                        No attachments
                                      </span>
                                    )}
                                  </div>
                                </td>
                                <td className="border px-3 py-2">
                                  {item.rejectedBy}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center py-3">
                                No history available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  )}

                {step?.title === "Final Billing Approval" &&
                  actionsToAccess?.includes(
                    "Approve Workorder Payment Request",
                  ) &&
                  savedData &&
                  JSON.parse(savedData.timelineValues || "{}")
                    ?.statusofPaymentRequest === false && (
                    <>
                      <div className="mt-4 p-5 rounded-2xl bg-red-50 border border-red-200 shadow-sm">
                        <h3 className="text-lg font-semibold text-red-700 mb-4">
                          Reject Payment
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {/* Comment */}
                          <div className="flex flex-col">
                            <label className="text-sm font-medium text-gray-700 mb-1">
                              Rejection Comment
                            </label>
                            <input
                              type="text"
                              className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-400"
                              placeholder="Enter rejection reason..."
                              onChange={(e) =>
                                handleChange("comment", e.target.value)
                              }
                            />
                          </div>

                          {/* File Upload */}
                          <div className="flex flex-col">
                            <label className="text-sm font-medium text-gray-700 mb-1">
                              Rejection Attachment
                            </label>
                            <input
                              type="file"
                              className="border border-gray-300 rounded-lg px-3 py-2 bg-white file:mr-3 file:py-1 file:px-3 file:rounded-md file:border-0 file:bg-red-100 file:text-red-700 hover:file:bg-red-200"
                              onChange={(e) =>
                                handleFileChange(
                                  "rejectAttachment",
                                  e.target.files,
                                )
                              }
                            />
                          </div>
                        </div>

                        {/* Action Button */}
                        <div className="mt-5 flex justify-end">
                          <button
                            className="bg-red-600 text-white px-5 py-2 rounded-lg shadow hover:bg-red-700 transition"
                            onClick={() => {
                              handleSaveStep(step, "rejected");
                            }}
                          >
                            Save Rejection
                          </button>
                        </div>
                      </div>
                      <div className="flex justify-end gap-4 mt-4">
                        {/* <button
                        onClick={() => {
                          setRejectMode((prev) => ({
                            ...prev,
                            [timeLineData.find(
                              (item) =>
                                item.title === "Final Billing Approval" &&
                                item?.status === true,
                            ).timelineId]: true,
                          }));
                        }}
                        className="bg-red-400 px-4 py-2 rounded"
                      >
                        Reject
                      </button> */}

                        <button
                          onClick={() =>
                            handleSaveStep(
                              timeLineData.find(
                                (item) =>
                                  item?.title === "Final Billing Approval" &&
                                  item?.status === true,
                              ),
                              "approvedforaccounts",
                            )
                          }
                          className="bg-blue-400 px-4 py-2 rounded"
                        >
                          Approve
                        </button>
                      </div>
                    </>
                  )}
              </div>
            )}

            {field.type === "file" ? (
              <div className="grid grid-cols-4 w-full">
                {value?.length
                  ? value.map((f, i) => {
                      const type = getFileType(f.url);

                      return (
                        <div key={i} className="w-12 h-12">
                          {type === "image" && (
                            <img
                              src={f.url}
                              onClick={() => {
                                handleImageOpen(
                                  f?.url || f?.Location || f?.image || f?.path,
                                );
                              }}
                              alt={`file-${i}`}
                              className="w-full h-full object-cover rounded cursor-pointer"
                            />
                          )}

                          {type === "video" && (
                            <video
                              src={f.url}
                              onClick={() => {
                                handleImageOpen(
                                  f?.url || f?.Location || f?.image || f?.path,
                                );
                              }}
                              className="w-full h-full object-cover rounded cursor-pointer"
                              controls
                            />
                          )}

                          {type === "pdf" && (
                            <a
                              href={f.url}
                              onClick={() => {
                                handleImageOpen(
                                  f?.url || f?.Location || f?.image || f?.path,
                                );
                              }}
                              target="_blank"
                              rel="noreferrer"
                              className="flex items-center justify-center w-full h-full bg-red-100 text-red-600 text-xs rounded cursor-pointer"
                            >
                              PDF
                            </a>
                          )}

                          {type === "document" && (
                            <a
                              href={f.url}
                              onClick={() => {
                                handleImageOpen(
                                  f?.url || f?.Location || f?.image || f?.path,
                                );
                              }}
                              // target="_blank"
                              // rel="noreferrer"
                              className="flex items-center justify-center w-full h-full bg-blue-100 text-blue-600 text-xs rounded cursor-pointer"
                            >
                              DOC
                            </a>
                          )}

                          {type === "unknown" && (
                            <a
                              href={f.url}
                              onClick={() => {
                                handleImageOpen(
                                  f?.url || f?.Location || f?.image || f?.path,
                                );
                              }}
                              target="_blank"
                              rel="noreferrer"
                              className="flex items-center justify-center w-full h-full bg-gray-100 text-gray-600 text-xs rounded"
                            >
                              FILE
                            </a>
                          )}
                        </div>
                      );
                    })
                  : "-"}
              </div>
            ) : (
              <p>{value || "-"}</p>
            )}
          </div>
        </>
      );
    });
  };

  const handleSaveStep = async (step, action) => {
    if (!token) {
      return toast.error("Session Expired close all the tabs and login again", {
        position: "top-end",
        style: {
          background: "red",
          color: "white",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }
    if (
      Object.keys(formData).length === 0 &&
      step?.title !== "Final Billing Approval"
    ) {
      return toast.error("Please fill the fields before saving", {
        position: "top-end",
        style: {
          background: "red",
          color: "white",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }
    if (
      step?.timelineId === "estimation" &&
      (!vehicleServicePartDetails.length)
    ) {
      toast.error(
        "Please add Part,Task and Labour details before adding estimation amount",
      );
      return;
    }
    if (
      step?.timelineId === "estimationApprovalFlow" &&
      (!vehicleTaskDetails.length || !vehicleServicePartDetails.length)
    ) {
      toast.error(
        "Please add Insurance, Task and Part details before approving",
      );
      return;
    }
    if (!token) return toast.error("Session expired");
    if (
      Number(formData?.startingOdometerReading) <
      Number(workOrderDetail?.odometerReading)
    ) {
      toast.error(
        "Starting Odometer Reading cannot be less than current Odometer Reading",
        {
          position: "top-end",
          style: {
            background: "red", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        },
      );
      return;
    }

    if (
      Number(formData?.endOdometerReading) <
      Number(
        JSON.parse(
          timeLineData.find((item) => item.title === "Vehicle pick up from Hub")
            ?.timelineValues || "{}",
        )?.startingOdometerReading,
      )
    ) {
      toast.error(
        "Vehicle drop to Service station odometer Reading cannot be less than Vehicle pick up from Hub Starting Odometer Reading",
        {
          position: "top-end",
          style: {
            background: "red", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        },
      );
      return;
    }

    if (
      Number(formData?.startingOdometerReading) <
      Number(
        JSON.parse(
          timeLineData.find(
            (item) => item.title === "Vehicle drop to Service station",
          )?.timelineValues || "{}",
        )?.endOdometerReading,
      )
    ) {
      toast.error(
        "Vehicle Pick From Service Station odometer Reading cannot be less than Vehicle drop to Service station end Odometer Reading",
        {
          position: "top-end",
          style: {
            background: "red", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        },
      );
      return;
    }

    if (
      Number(formData?.endOdometerReading) <
      Number(
        JSON.parse(
          timeLineData.find(
            (item) => item.title === "Vehicle Pick From Service Station",
          )?.timelineValues || "{}",
        )?.startingOdometerReading,
      )
    ) {
      toast.error(
        "Ending Odometer Reading cannot be less than Vehicle Pick From Service Station Starting Odometer Reading",
        {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        },
      );
      return;
    }

    // FUEL READING VALIDATIONS

    // if (
    //   Number(formData?.endFuelReading) >
    //   Number(
    //     JSON.parse(
    //       timeLineData.find((item) => item.title === "Vehicle pick up from Hub")
    //         ?.timelineValues || "{}",
    //     )?.startingFuelReading,
    //   )
    // ) {
    //   toast.error("Drop fuel reading cannot be less than pickup fuel reading", {
    //     position: "top-end",
    //     style: {
    //       background: "red",
    //       color: "white",
    //       marginBottom: "50px",
    //     },
    //   });
    //   return;
    // }

    // if (
    //   Number(formData?.startingFuelReading) >
    //   Number(
    //     JSON.parse(
    //       timeLineData.find(
    //         (item) => item.title === "Vehicle drop to Service station",
    //       )?.timelineValues || "{}",
    //     )?.endFuelReading,
    //   )
    // ) {
    //   toast.error("Pickup fuel reading cannot be more than drop fuel reading", {
    //     position: "top-end",
    //     style: {
    //       background: "red",
    //       color: "white",
    //       marginBottom: "50px",
    //     },
    //   });
    //   return;
    // }

    // if (
    //   Number(formData?.endFuelReading) >
    //   Number(
    //     JSON.parse(
    //       timeLineData.find(
    //         (item) => item.title === "Vehicle Pick From Service Station",
    //       )?.timelineValues || "{}",
    //     )?.startingFuelReading,
    //   )
    // ) {
    //   toast.error(
    //     "Final fuel reading cannot be more than pickup fuel reading",
    //     {
    //       position: "bottom-center",
    //       style: {
    //         background: "red",
    //         color: "white",
    //         marginBottom: "50px",
    //       },
    //     },
    //   );
    //   return;
    // }

    if (
      !formData?.endFuelReading &&
      (step?.title === "Vehicle drop to Service station" ||
        step?.title === "Vehicle Drop To Hub")
    ) {
      toast.error("Select Fuel Reading percentage", {
        position: "top-end",
        style: {
          background: "red",
          color: "white",
          marginBottom: "50px",
        },
      });
      return;
    } else if (
      !formData?.startingFuelReading &&
      (step?.title === "Vehicle pick up from Hub" ||
        step?.title === "Vehicle Pick From Service Station")
    ) {
      toast.error("Select Fuel Reading percentage", {
        position: "top-end",
        style: {
          background: "red",
          color: "white",
          marginBottom: "50px",
        },
      });
      return;
    }

    // ODOMETER IMAGE

    if (
      !formData?.endOdometerImage &&
      (step?.title === "Vehicle drop to Service station" ||
        step?.title === "Vehicle Drop To Hub")
    ) {
      toast.error("Upload odometer image", {
        position: "top-end",
        style: {
          background: "red",
          color: "white",
          marginBottom: "50px",
        },
      });
      return;
    } else if (
      !formData?.startingOdometerImage &&
      (step?.title === "Vehicle pick up from Hub" ||
        step?.title === "Vehicle Pick From Service Station")
    ) {
      toast.error("Upload odometer image", {
        position: "top-end",
        style: {
          background: "red",
          color: "white",
          marginBottom: "50px",
        },
      });
      return;
    }

    // STEP 3 → Move estimation back
    const estimationStep = timeLine.find(
      (item) => item.timelineId === "estimation",
    );

    const revertPayload = {
      id: timeLineData.find((item) => item.title === "Service Estimation")?.id,
      serviceLogId: workOrderDetail?.id,
      status: 0,
      timelineId: estimationStep?.id,
      title: estimationStep?.title,
      serviceObject: {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.estimationPending,
      },
      timelineValues: JSON.stringify({
        comment: formData?.comment,
        rejectAttachment: rejectMode?.rejectAttachment,
        serviceEstimationHistories: [
          ...(estimationHistory || []),
          {
            estimationAmount: timeLineData.find(
              (item) => item.title === "Service Estimation",
            )?.timelineValues
              ? JSON.parse(
                  timeLineData.find(
                    (item) => item.title === "Service Estimation",
                  )?.timelineValues || "{}",
                )?.estimationAmount
              : null,
            description: formData?.description,
            comment: formData?.comment,
            rejectedBy: profile?.name,
            rejectAttachment: rejectMode?.rejectAttachment,
          },
        ],
      }),
    };

    let payload;

    if (step.timelineId === "hubPickUpForm") {
      console.log("1");
      payload = {
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.isEnrouteToGarage = true;
      payload.newNrkObject = {
        startOdometer: formData?.startingOdometerReading,
        startFuelLevel: formData?.startingFuelReading,
        tripStart: moment().format("YYYY-MM-DDTHH:mm"),
        startOdometerImage:
          formData?.startingOdometerImage &&
          formData?.startingOdometerImage[0]?.url,
        vehicleId: workOrderDetail?.vehicleId,
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        source: "Admin",
      });
    } else if (step.timelineId === "dropServiceStation") {
      console.log("2");
      payload = {
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.isEnrouteToGarage = true;
      payload.nonRevenueObject = {
        endOdometer: formData?.endOdometerReading,
        endFuelLevel: formData?.endFuelReading,
        tripEnd: moment().format("YYYY-MM-DDTHH:mm"),
        endOdmoeterImage:
          formData?.endOdometerImage && formData?.endOdometerImage[0]?.url,
        nrkId: JSON.parse(
          timeLineData.find((item) => item.title === "Vehicle pick up from Hub")
            ?.timelineValues || "{}",
        )?.nrkId,
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        source: "Admin",
      });
    } else if (step.timelineId === "pickupFromServiceStation") {
      console.log("3");
      payload = {
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.isEnrouteToHub = true;
      payload.newNrkObject = {
        startOdometer: formData?.startingOdometerReading,
        startFuelLevel: formData?.startingFuelReading,
        tripStart: moment().format("YYYY-MM-DDTHH:mm"),
        startOdometerImage:
          formData?.startingOdometerImage &&
          formData?.startingOdometerImage[0]?.url,
        vehicleId: workOrderDetail?.vehicleId,
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        source: "Admin",
      });
    } else if (step.timelineId === "vehicleDropToHub") {
      console.log("4");
      payload = {
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.isEnrouteToHub = true;
      payload.nonRevenueObject = {
        endOdometer: formData?.endOdometerReading,
        endFuelLevel: formData?.endFuelReading,
        tripEnd: moment().format("YYYY-MM-DDTHH:mm"),
        endOdmoeterImage:
          formData?.endOdometerImage && formData?.endOdometerImage[0]?.url,
        nrkId: JSON.parse(
          timeLineData.find(
            (item) => item.title === "Vehicle Pick From Service Station",
          )?.timelineValues || "{}",
        )?.nrkId,
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        source: "Admin",
      });
    }
    else if (step.timelineId === "estimation" && step.title !==
        timeLineData.find((item) => item.title === "Service Estimation")?.title) {
      console.log("5")
      payload = {
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        serviceEstimationHistories: estimationHistory,
        source: "Admin",
      });
      payload.serviceObject = {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.estimationApprovalPending,
      };
    }
    // else if (step.timelineId === "estimation" && action === "rejected") {
    //   payload = {
    //     id: timeLineData.find((item) => item.title === "Service Estimation")
    //       ?.id,
    //     serviceLogId: workOrderDetail?.id,
    //     status: 1,
    //     timelineId: step.id,
    //     title: step.title,
    //     timelineValues: JSON.stringify(formData),
    //     attachment: JSON.stringify(formData?.attachment),
    //   };
    //   payload.timelineValues = JSON.stringify({
    //     ...formData,
    //     serviceEstimationHistories: estimationHistory,
    //     source: "Admin",
    //   });
    //   payload.serviceObject = {
    //     id: workOrderDetail?.id,
    //     serviceStatus: workorderStatus?.inverted?.estimationApprovalPending,
    //   };
    // }
    else if (
      step.title === "Service Estimation" &&
      step?.id ===
        timeLineData.find((item) => item.title === "Service Estimation")
          ?.timelineId
    ) {
      console.log("6");
      payload = {
        id: timeLineData.find((item) => item.title === "Service Estimation")
          ?.id,
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        comment: formData?.comment,
        rejectAttachment: rejectMode?.rejectAttachment,
        statusofPaymentRequest: false,
        paymentRequestRequestHistories: [
          ...(estimationHistory || []),
          {
            paymentAmount: timeLineData.find(
              (item) => item.title === "Service Estimation",
            )?.timelineValues
              ? JSON.parse(
                  timeLineData.find(
                    (item) => item.title === "Service Estimation",
                  )?.timelineValues || "{}",
                )?.estimationAmount
              : null,
            description: formData?.description,
            comment: formData?.comment,
            rejectedBy: profile?.name,
            rejectAttachment: rejectMode?.rejectAttachment,
          },
        ],
      });
      payload.serviceObject = {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.estimationApprovalPending,
      };
    } else if (
      step.timelineId === "estimationApprovalFlow" &&
      action === "approved"
    ) {
      console.log("7");
      payload = {
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        insuranceAmount: workOrderDetail?.amountClaimed,
        estimatedAmount:
          JSON.parse(
            timeLineData.find((item) => item.title === "Service Estimation")
              ?.timelineValues || "{}",
          )?.estimationAmount || 0,
        totalTaskAmount: vehicleTaskDetails?.reduce(
          (sum, item) => sum + Number(item.totalCost || 0),
          0,
        ),
        totalPartsAmount: vehicleServicePartDetails?.reduce(
          (sum, item) => sum + Number(item.totalCost || 0),
          0,
        ),
        approvedBy: profile?.name,
        source: "Admin",
      });
      payload.serviceObject = {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.inProgress,
      };
    } else if (
      step.timelineId === "estimationApprovalFlow" &&
      action === "rejected"
    ) {
      console.log("8");
      payload = {
        id: timeLineData.find((item) => item.title === "Estimation Approval")
          ?.id,
        serviceLogId: workOrderDetail?.id,
        status: 0,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify({
          comment: formData?.comment,
          rejectAttachment: rejectMode?.rejectAttachment,
          serviceEstimationHistories: [
            ...(estimationHistory || []),
            {
              estimationAmount: timeLineData.find(
                (item) => item.title === "Service Estimation",
              )?.timelineValues
                ? JSON.parse(
                    timeLineData.find(
                      (item) => item.title === "Service Estimation",
                    )?.timelineValues || "{}",
                  )?.estimationAmount
                : null,
              description: formData?.description,
              comment: formData?.comment,
              rejectedBy: profile?.name,
              rejectAttachment: rejectMode?.rejectAttachment,
            },
          ],
        }),
      };
    } else if (
      step.timelineId === "finalBillingRequest" &&
      action === "rejected"
    ) {
      console.log("9");
      payload = {
        id: timeLineData.find((item) => item.title === "Final Billing Approval")
          ?.id,
        serviceLogId: workOrderDetail?.id,
        status: 0,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify({
          paymentAmount: timeLineData.find(
            (item) => item.title === "Final Billing Approval",
          )?.timelineValues
            ? JSON.parse(
                timeLineData.find(
                  (item) => item.title === "Final Billing Approval",
                )?.timelineValues || "{}",
              )?.paymentAmount
            : {},
          attachments: timeLineData.find(
            (item) => item.title === "Final Billing Approval",
          )?.attachments,
          comment: formData?.comment,
          rejectAttachment: rejectMode?.rejectAttachment,
          statusofPaymentRequest: false,
          paymentRequestRequestHistories: [
            ...(paymentRejectHistory || []),
            {
              paymentAmount: timeLineData.find(
                (item) => item.title === "Final Billing Approval",
              )?.timelineValues
                ? JSON.parse(
                    timeLineData.find(
                      (item) => item.title === "Final Billing Approval",
                    )?.timelineValues || "{}",
                  )?.paymentAmount
                : null,
              description: formData?.description,
              comment: formData?.comment,
              rejectedBy: profile?.name,
              rejectAttachment: rejectMode?.rejectAttachment,
            },
          ],
        }),
      };
      payload.serviceObject = {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.billingRequestRejected,
      };
    } else if (
      step.title === "Final Billing Approval" &&
      action === "approvedforaccounts"
    ) {
      console.log("10");
      const existingValues = JSON.parse(
        timeLineData.find((item) => item.title === "Final Billing Approval")
          ?.timelineValues || "{}",
      );
      payload = {
        id: timeLineData.find((item) => item.title === "Final Billing Approval")
          ?.id,
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.timelineId,
        title: step.title,
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.timelineValues = JSON.stringify({
        ...existingValues,
        statusofPaymentRequest: true,
        approvedBy: profile?.name,
        requestRaisedStatus: false,
        source: "Admin",
      });
      payload.serviceObject = {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.billingApproved,
      };
    } else if (
      step.title === "Final Billing Approval" &&
      step?.id ===
        timeLineData.find((item) => item.title === "Final Billing Approval")
          ?.timelineId
    ) {
      console.log("11");
      payload = {
        id: timeLineData.find((item) => item.title === "Final Billing Approval")
          ?.id,
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        statusofPaymentRequest: false,
        requestRaisedStatus: true,
        source: "Admin",
        comment: formData?.comment,
        rejectAttachment: rejectMode?.rejectAttachment,
        statusofPaymentRequest: false,
        paymentRequestRequestHistories: [
          ...(paymentRejectHistory || []),
          // {
          //   paymentAmount: timeLineData.find(
          //     (item) => item.title === "Final Billing Approval",
          //   )?.timelineValues
          //     ? JSON.parse(
          //         timeLineData.find(
          //           (item) => item.title === "Final Billing Approval",
          //         )?.timelineValues || "{}",
          //       )?.paymentAmount
          //     : null,
          //   description: formData?.description,
          //   comment: formData?.comment,
          //   rejectedBy: profile?.name,
          //   rejectAttachment: rejectMode?.rejectAttachment,
          // },
        ],
      });
      payload.serviceObject = {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.billingApprovalRequest,
      };
    } else if (step.title === "Final Billing Approval") {
      console.log("12");
      payload = {
        id: timeLineData.find((item) => item.title === "Final Billing Approval")
          ?.id,
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        statusofPaymentRequest: false,
        requestRaisedStatus: true,
        source: "Admin",
      });
      payload.serviceObject = {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.billingApprovalRequest,
      };
    } else if (step.title === "Service Complete") {
      console.log("13");
      payload = {
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.serviceObject = {
        id: workOrderDetail?.id,
        serviceStatus: workorderStatus?.inverted?.serviceCompleted,
      };
    } else {
      console.log("14");
      payload = {
        serviceLogId: workOrderDetail?.id,
        status: 1,
        timelineId: step.id,
        title: step.title,
        timelineValues: JSON.stringify(formData),
        attachment: JSON.stringify(formData?.attachment),
      };
      payload.timelineValues = JSON.stringify({
        ...formData,
        source: "Admin",
      });
    }

    console.log("Payload to save:", payload);
    // return;

    try {
      const res = await fetch(`${apiUrl}/api/servicetimelines`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        if (
          step.timelineId === "estimationApprovalFlow" &&
          action === "rejected" &&
          rejectMode
        ) {
          console.log("INSIDE REJECTION UPDATION OF 3RD STEP");
          await fetch(`${apiUrl}/api/servicetimelines`, {
            method: "POST",
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(revertPayload),
          });
        }
        if (step.title === "Service Complete") {
          await fetch(`${apiUrl}/api/vehicleservices`, {
            method: "POST",
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: workOrderDetail?.id,
              isPaymentPending: workOrderDetail?.isPaymentPending
                ? true
                : false,
              endingOdometer: JSON.parse(
                timeLineData.find(
                  (item) => item.title === "Vehicle Drop To Hub",
                )?.timelineValues || "{}",
              )?.endOdometerReading,
              endingOdometerImage: JSON.parse(
                timeLineData.find(
                  (item) => item.title === "Vehicle Drop To Hub",
                )?.timelineValues || "{}",
              )?.endOdometerImage,
            }),
          });
          await fetch(`${apiUrl}/api/vehicles`, {
            method: "POST",
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: workOrderDetail?.vehicleId,
              currentOdometer: JSON.parse(
                timeLineData.find(
                  (item) => item.title === "Vehicle Drop To Hub",
                )?.timelineValues || "{}",
              )?.endOdometerReading,
            }),
          });
        }
        toast.success(`${step.title} saved successfully`);
        setFormData({});
        setOpenIndex(null);
        await getTimeLIneDataDetails(workOrderDetail.id);
        await getWorkOrderDetails(selectedRow?.id);
      }
    } catch {
      toast.error("Error");
    }
  };

  return (
    <>
      {loading ? (
        <div>
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent border-dashed rounded-full animate-spin"></div>
          <h1>Loading Please Wait</h1>
        </div>
      ) : (
        <div className="p-4">
          {timeLine.map((step, index) => {
            const savedData = timeLineData.find(
              (item) => item.timelineId === step.id && item.status === true,
            );
            const savedValues = parseTimelineValues(savedData);
            const createdBy =
              isSystemUserList.find(
                (user) => user?.id === savedValues?.createdBy,
              )?.name ||
              isSystemUserList.find((user) => user?.id === savedData?.createdBy)
                ?.name;
            const updatedBy =
              isSystemUserList.find(
                (user) => user?.id === savedValues?.updatedBy,
              )?.name ||
              isSystemUserList.find((user) => user?.id === savedData?.updatedBy)
                ?.name;
            const approvedBy = savedValues?.approvedBy;

            return (
              <div key={step.id} className="mb-4 border rounded-xl bg-white">
                <div
                  onClick={() => toggleAccordion(index)}
                  className="flex justify-between items-start gap-4 p-3 cursor-pointer"
                >
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg font-semibold break-words">
                      {step.seqId}. {step.title}
                    </h3>

                    {(createdBy || updatedBy || approvedBy) && (
                      <div className="text-sm text-gray-500 mt-1 flex flex-wrap gap-x-4 gap-y-1">
                        {createdBy && <span>Created by: {createdBy}</span>}
                        {updatedBy && <span>Updated by: {updatedBy}</span>}

                        {approvedBy &&
                          (step?.title === "Estimation Approval" ||
                            step?.title === "Final Billing Approval") && (
                            <span>Approved by: {approvedBy}</span>
                          )}
                      </div>
                    )}

                    {savedValues?.source && (
                      <div className="text-xs text-gray-500 mt-1 break-words">
                        Source: {savedValues.source}
                      </div>
                    )}
                  </div>

                  <span
                    className={`px-3 py-1 rounded text-sm whitespace-nowrap self-start flex-shrink-0 ${
                      savedValues?.requestRaisedStatus && savedData?.status
                        ? "bg-purple-200"
                        : savedData?.status
                          ? "bg-green-200"
                          : "bg-yellow-200"
                    }`}
                  >
                    {savedValues?.requestRaisedStatus && savedData?.status
                      ? "Request Raised for Approval"
                      : savedData?.status
                        ? "Completed"
                        : "Pending"}
                  </span>
                </div>

                {openIndex === index && (
                  <>
                    <div className="p-4">
                      {savedData
                        ? renderSavedData(step, savedData)
                        : renderInputs(step)}
                    </div>
                    {!savedData && (
                      <div className="p-4 text-right">
                        {rejectMode[step.id] &&
                          step.timelineId === "estimationApprovalFlow" && (
                            <div className="mt-4 p-5 rounded-2xl bg-red-50 border border-red-200 shadow-sm">
                              <h3 className="text-lg font-semibold text-red-700 mb-4">
                                Reject Estimation
                              </h3>

                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {/* Comment */}
                                <div className="flex flex-col">
                                  <label className="text-sm font-medium text-gray-700 mb-1">
                                    Rejection Comment
                                  </label>
                                  <input
                                    type="text"
                                    className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-400"
                                    placeholder="Enter rejection reason..."
                                    onChange={(e) =>
                                      handleChange("comment", e.target.value)
                                    }
                                  />
                                </div>

                                {/* File Upload */}
                                <div className="flex flex-col">
                                  <label className="text-sm font-medium text-gray-700 mb-1">
                                    Rejection Attachment
                                  </label>
                                  <input
                                    type="file"
                                    className="border border-gray-300 rounded-lg px-3 py-2 bg-white file:mr-3 file:py-1 file:px-3 file:rounded-md file:border-0 file:bg-red-100 file:text-red-700 hover:file:bg-red-200"
                                    onChange={(e) =>
                                      handleFileChange(
                                        "rejectAttachment",
                                        e.target.files,
                                      )
                                    }
                                  />
                                </div>
                              </div>

                              {/* Action Button */}
                              <div className="mt-5 flex justify-end">
                                <button
                                  className="bg-red-600 text-white px-5 py-2 rounded-lg shadow hover:bg-red-700 transition"
                                  onClick={() => {
                                    handleSaveStep(step, "rejected");
                                  }}
                                >
                                  Save Rejection
                                </button>
                              </div>
                            </div>
                          )}
                        {actionsToAccess?.includes(
                          "Approve Workorder Estimation",
                        ) ? (
                          <div className="flex justify-end gap-4">
                            {step?.timelineId === "estimationApprovalFlow" && (
                              <button
                                onClick={() => {
                                  setRejectMode((prev) => ({
                                    ...prev,
                                    [step.id]: true,
                                  }));
                                }}
                                className="bg-red-400 px-4 py-2 rounded"
                              >
                                Reject
                              </button>
                            )}
                            <button
                              onClick={() => handleSaveStep(step, "approved")}
                              className="bg-blue-400 px-4 py-2 rounded"
                            >
                              {step?.timelineId === "estimationApprovalFlow"
                                ? "Approve"
                                : "Save"}
                            </button>
                          </div>
                        ) : !savedData &&
                          step?.timelineId !== "estimationApprovalFlow" ? (
                          <button
                            disabled={isSaveDisabledForStep(step)}
                            onClick={() =>
                              !isSaveDisabledForStep(step) &&
                              handleSaveStep(step)
                            }
                            className={`bg-blue-400 px-4 py-2 rounded ${isSaveDisabledForStep(step) ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-500"}`}
                          >
                            Save
                          </button>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default Servicetimeline;
